export default __webpack_public_path__ + "static/Scroll-Image---Garage-Demolition-2a068c0729c6bd57fcc572369e2b743a.jpg";